import { render, staticRenderFns } from "./DailyCheckSettings.vue?vue&type=template&id=4d528c30&"
import script from "./DailyCheckSettings.vue?vue&type=script&lang=js&"
export * from "./DailyCheckSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports